import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { KeyRound, AlertCircle, MailCheck, ArrowLeft } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PasswordDimenticata() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Si è verificato un errore. Riprova più tardi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-12 px-4">
      <Card className="w-full max-w-md shadow-[var(--shadow-md)]" data-testid="forgot-password-card">
        <CardHeader className="text-center">
          <div className="w-12 h-12 bg-[#238A92] rounded-xl flex items-center justify-center text-white mx-auto mb-2">
            {sent ? <MailCheck size={24} /> : <KeyRound size={24} />}
          </div>
          <CardTitle className="text-2xl" style={{fontFamily:'Space Grotesk'}}>{sent ? 'Controlla la tua email' : 'Password dimenticata?'}</CardTitle>
          <CardDescription>
            {sent
              ? 'Se l\'indirizzo è registrato, ti abbiamo inviato un link per reimpostare la password. Il link è valido per 60 minuti.'
              : 'Inserisci l\'email del tuo account: ti invieremo un link per scegliere una nuova password.'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="space-y-4" data-testid="forgot-password-success">
              <p className="text-sm text-muted-foreground text-center">Non hai ricevuto nulla? Controlla la cartella spam oppure <button type="button" onClick={() => setSent(false)} className="text-[#238A92] hover:underline font-medium" data-testid="forgot-password-retry-btn">riprova</button>.</p>
              <Link to="/login">
                <Button variant="outline" className="w-full" data-testid="forgot-password-back-login-btn"><ArrowLeft size={15} className="mr-1" /> Torna al login</Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <Alert variant="destructive" data-testid="forgot-password-error">
                  <AlertCircle size={16} />
                  <AlertDescription>{error}</AlertDescription>
                </Alert>
              )}
              <div className="space-y-2">
                <Label htmlFor="fp-email">Email</Label>
                <Input id="fp-email" type="email" placeholder="nome@esempio.com" value={email} onChange={e => setEmail(e.target.value)} required autoFocus data-testid="forgot-password-email-input" />
              </div>
              <Button type="submit" className="w-full bg-[#238A92] hover:bg-[#0F5E66] text-white" disabled={loading} data-testid="forgot-password-submit-btn">
                {loading ? 'Invio in corso...' : 'Invia link di reset'}
              </Button>
              <p className="text-center text-sm text-muted-foreground">
                <Link to="/login" className="text-[#238A92] hover:underline font-medium inline-flex items-center gap-1" data-testid="forgot-password-login-link"><ArrowLeft size={13} /> Torna al login</Link>
              </p>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
